import { store as marketplace } from '../use-cases/marketplace'
import { store as events } from '../use-cases/events'
import { store as dashboard } from '../use-cases/dashboard'
import { store as bookings } from '../use-cases/bookings'

export default {
    marketplace,
    events,
    dashboard,
    bookings
}